import { Platform, Linking } from 'react-native';
import * as WebBrowser from 'expo-web-browser';
import { cdnUrl } from '../config/env';
import { Source, REPORT_STATUS, LOST_RECEIPT_OPTION } from '../constants/Enums';
import { ManualCategoryField, expenseActions } from './useExpenseWidget';
import { DynamoDBFieldNames, ExpenseCategories } from '../constants/ExpenseCategories';
import { appendReportNumber } from './expense.utils';

export const ValidateZipCodeByCountryCode = (zip, countryCode) => {
  let status = true;

  if (!zip || zip.toString().length < 2 || zip.toString().length > 10) {
    status = false;
  } else {
    let regexText = '';

    switch (countryCode) {
      case 'AF': //Afghanistan
      case 'AL': //Albania
      case 'AM': //Armenia
      case 'AU': //Australia
      case 'AT': //Austria
      case 'BD': //Bangladesh
      case 'BE': //Belgium
      case 'BO': //Bolivia
      case 'BG': //Bu,lgaria
      case 'CV': //Cape Verde
      case 'CX': //Christmas Island
      case 'CC': //Cocos (Keeling) Island
      case 'CY': //Cyprus
      case 'ET': //Ethiopia
      case 'GE': //Georgia
      case 'GL': //Greenland
      case 'GW': //Guinea Bissau
      case 'HT': //Haiti
      case 'HM': //Heard and McDonald Islands
      case 'HU': //Hungary
      case 'LR': //Liberia
      case 'LI': //Liechtenstein
      case 'LU': //Luxembourg
      case 'MK': //Macedonia
      case 'MZ': //Mozambique
      case 'NZ': //New Zealand
      case 'NE': //Niger
      case 'NF': //Norfolk Island
      case 'NO': //Norway
      case 'PY': //Paraguay
      case 'PH': //Philippines
      case 'ZA': //South Africa
      case 'CH': //Switzerland
      case 'SJ': //Svalbard and Jan Mayen
      case 'TN': //Tunisia
        regexText = /^\d{4}$/;
        break;
      case 'AX': //�land Islands
      case 'DZ': //Algeria
      case 'BT': //Bhutan
      case 'BA': //Bosnia and Herzegovina
      case 'KH': //Cambodia
      case 'TD': //Chad
      case 'HR': //Croatia
      case 'CU': //Cuba
      case 'DO': //Dominican Republic
      case 'EG': //Egypt
      case 'EE': //Estonia
      case 'FI': //Finland
      case 'FR': //France
      case 'DE': //Germany
      case 'GU': //Guam
      case 'GT': //Guatemala
      case 'HN': //Honduras
      case 'ID': //Indonesia
      case 'IQ': //Iraq
      case 'IT': //Italy
      case 'JO': //Jordan
      case 'KE': //Kenya
      case 'XK': //Kosovo
      case 'KW': //Kuwait
      case 'LA': //Laos
      case 'LY': //Libya
      case 'MY': //Malaysia
      case 'MH': //Marshall Islands
      case 'FM': //Micronesia
      case 'MX': //Mexico
      case 'MN': //Mongolia
      case 'ME': //Montserrat
      case 'MA': //Morocco
      case 'MM': //Myanmar
      case 'NA': //Namibia
      case 'NP': //Nepal
      case 'NI': //Nicaragua
      case 'MP': //Northern Mariana Islands
      case 'PK': //Pakistan
      case 'PW': //Palau
      case 'PE': //Peru
      case 'PR': //Puerto Rico
      case 'SN': //Senegal
      case 'RS': //Serbia
      case 'ES': //Spain
      case 'LK': //Sri Lanka
      case 'SD': //Sudan
      case 'TW': //Taiwan
      case 'TH': //Thailand
      case 'TR': //Turkey
      case 'UA': //Ukraine
      case 'UY': //Uruguay
      case 'VI': //U.S. Virgin Islands
      case 'ZM': //Zambia
        regexText = /^\d{5}$/;
        break;
      case 'AS': //American Samoa
        regexText = /^\d{5}(-{1}\d{4,6})$/;
        break;
      case 'AD': //Andorra
        regexText = /^[Aa][Dd]\d{3}$/;
        break;
      case 'AO': //Angola -------
      case 'AG': //Antigua and Barbuda
      case 'AW': //Aruba
      case 'BS': //Bahamas
      case 'BZ': //Belize
      case 'BJ': //Benin
      case 'BW': //Botswana
      case 'BF': //Burkina Faso
      case 'BI': //Burundi
      case 'CM': //Cameroon
      case 'CF': //Central African Republic
      case 'KM': //Comoros
      case 'CG': //Congo (Brazzaville)
      case 'CK': //Cook Islands
      case 'CI': //C�te d'Ivoire (Ivory Coast)
      case 'CW': //Cura�ao
      case 'DK': //Denmark
      case 'DM': //Dominica
      case 'TL': //East Timor
      case 'GQ': //Equatorial Guinea
      case 'ER': //Eritrea
      case 'FJ': //Fiji
      case 'TF': //French Southern and Antarctic Territories
      case 'GM': //Gambia
      case 'GH': //Ghana
      case 'GD': //Grenada
      case 'GN': //Guinea
      case 'GY': //Guyana
      case 'HK': //Hong Kong
      case 'IE': //Ireland
      case 'KI': //Kiribati
      case 'KP': //Korea, North
      case 'MO': //Macau
      case 'MW': //Malawi
      case 'ML': //Mali
      case 'MR': //Mauritania
      case 'MU': //Mauritius
      case 'NR': //Nauru
      case 'NU': //Niue
      case 'QA': //Qatar
      case 'KN': //Saint Kitts and Nevis
      case 'LC': //Saint Lucia
      case 'ST': //Sao Tome and Principe
      case 'SC': //Seychelles
      case 'SL': //Sierra Leone
      case 'SB': //Solomon Islands
      case 'SO': //Somalia
      case 'SR': //Suriname
      case 'SY': //Syria
      case 'TZ': //Tanzania
      case 'TG': //Togo
      case 'TK': //Tokelau
      case 'TO': //Tonga
      case 'TV': //Tuvalu
      case 'UG': //Uganda
      case 'AE': //United Arab Emirates
      case 'VU': //Vanuatu
      case 'YE': //Yemen
      case 'ZW': //Zimbabwe
        regexText = /^\d{4}$/;
        break;
      case 'AI': //Anguilla
        regexText = /^[Aa][I][-][2][6][4][0]$/;
        break;
      case 'AR': //Argentina
        regexText = /^\d{4}|[A-Za-z]\d{4}[a-zA-Z]{3}$/;
        break;
      case 'AC': //Ascension island
        regexText = /^[Aa][Ss][Cc][Nn]\s{0,1}[1][Zz][Zz]$/;
        break;
      case 'AZ': //Azerbaijan
        regexText = /^[Aa][Zz]\d{4}$/;
        break;
      case 'BH': //Bahrain
        regexText = /^\d{3,4}$/;
        break;
      case 'BB': //Barbados
        regexText = /^[Aa][Zz]\d{5}$/;
        break;
      case 'BY': //Belarus
      case 'CN': //China
      case 'CO': //Colombia
      case 'EC': //Ecuador
      case 'IN': //India
      case 'KZ': //Kazakhstan
      case 'KG': //Kyrgyzstan
      case 'NG': //Nigeria
      case 'PA': //Panama
      case 'RO': //Romania
      case 'RU': //Russia
      case 'SG': //Singapore
      case 'TJ': //Tajikistan
      case 'TT': //Trinidad and Tobago
      case 'TM': //Turkmenistan
      case 'VN': //Vietnam
        regexText = /^\d{6}$/;
        break;
      case 'BM': //Bermuda
        regexText = /^[A-Za-z]{2}\s([A-Za-z]{2}|\d{2})$/;
        break;
      case 'BR': //Brazil
        regexText = /^\d{5}-\d{3}$/;
        break;
      case 'IO': //British Indian Ocean Territory
        regexText = /^[Bb]{2}[Nn][Dd]\s{0,1}[1][Zz]{2}$/;
        break;
      case 'VG': //British Virgin Islands
        regexText = /^[Vv][Gg]\d{4}$/;
        break;
      case 'BN': //Brunei
        regexText = /^[A-Za-z]{2}\d{4}$/;
        break;
      case 'CA': //Canada
        regexText = /^(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\s{0,1}\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d$/;
        break;
      case 'KY': //Cayman Islands
        regexText = /^[Kk][Yy]\d[-\s]{0,1}\d{4}$/;
        break;
      case 'CL': //Chile
        regexText = /^\d{7}\s\(\d{3}-\d{4}\)$/;
        break;
      case 'CD': //Congo, Democratic Republic
        regexText = /^[Cc][Dd]$/;
        break;
      case 'CR': //Costa Rica
      case 'MV': //Maldives
        regexText = /^\d{4,5}$/;
        break;
      case 'CZ': //Czech Republic
        regexText = /^\d{5}\s\(\d{3}\s\d{2}\)$/;
        break;
      case 'SV': //El Salvador
        regexText = /^1101$/;
        break;
      case 'FK': //Falkland Islands
        regexText = /^[Ff][Ii][Qq]{2}\s{0,1}[1][Zz]{2}$/;
        break;
      case 'FO': //Faroe Islands
      case 'IS': //Iceland
      case 'LS': //Lesotho
      case 'MG': //Madagascar
      case 'OM': //Oman
      case 'PG': //Papua New Guinea
        regexText = /^\d{3}$/;
        break;
      case 'GF': //French Guiana
        regexText = /^973\d{2}$/;
        break;
      case 'PF': //French Polynesia
        regexText = /^987\d{2}$/;
        break;
      case 'GA': //Gabon
        regexText = /^\d{2}\s[a-zA-Z-_ ]\s\d{2}$/;
        break;
      case 'GI': //Gibraltar
        regexText = /^[Gg][Xx][1]{2}\s{0,1}[1][Aa]{2}$/;
        break;
      case 'GR': //Greece
        regexText = /^\d{3}\s{0,1}\d{2}$/;
        break;
      case 'GP': //Guadeloupe
        regexText = /^971\d{2}$/;
        break;
      case 'GG': //Guernsey
        regexText = /^[A-Za-z]{2}\d\s{0,1}\d[A-Za-z]{2}$/;
        break;
      case 'IR': //Iran
        regexText = /^\d{5}-\d{5}$/;
        break;
      case 'IM': //Isle of Man
        regexText = /^[Ii[Mm]\d{1,2}\s\d\[A-Z]{2}$/;
        break;
      case 'IL': //Israel
        regexText = /^\b\d{5}(\d{2})?$/;
        break;
      case 'JM': //Jamaica
        regexText = /^\d{2}$/;
        break;
      case 'JP': //Japan
        regexText = /^\b\d{3}\b(?:[- ]{1}\d{4})?$/;
        break;
      case 'JE': //Jersey
        regexText = /^[Jj][Ee]\d\\{0,1}\d[A-Za-z]{2}$/;
        break;
      case 'KR': //Korea, South
        regexText = /^\d{6}\s\(\d{3}-\d{3}\)$/;
        break;
      case 'LV': //Latvia
        regexText = /^[Ll][Vv][- ]{0,1}\d{4}$/;
        break;
      case 'LB': //Lebanon
        regexText = /^\d{4}\s{0,1}\d{4}$/;
        break;
      case 'LT': //Lithuania
        regexText = /^[Ll][Tt][- ]{0,1}\d{5}$/;
        break;
      case 'MT': //Malta
        regexText = /^[A-Za-z]{3}\s{0,1}\d{4}$/;
        break;
      case 'MQ': //Martinique
        regexText = /^972\d{2}$/;
        break;
      case 'YT': //Mayotte
        regexText = /^976\d{2}$/;
        break;
      case 'MD': //Moldova
        regexText = /^[Mm][Dd][- ]{0,1}\d{4}$/;
        break;
      case 'MC': //Monaco
        regexText = /^980\d{2}$/;
        break;
      case 'MS': //Afghanistan
        regexText = /^[Mm][Ss][Rr]\s{0,1}\d{4}$/;
        break;
      case 'NL': //Netherlands
        regexText = /^\d{4}\s{0,1}[A-Za-z]{2}$/;
        break;
      case 'NC': //New Caledonia
        regexText = /^988\d{2}$/;
        break;
      case 'PN': //Pitcairn Islands
        regexText = /^[Pp][Cc][Rr][Nn]\s{0,1}[1][Zz]{2}$/;
        break;
      case 'PL': //Poland
        regexText = /^\d{2}[- ]{0,1}\d{3}$/;
        break;
      case 'PT': //Portugal
        regexText = /^\d{4}[- ]{0,1}\d{3}$/;
        break;
      case 'RE': //R�union
        regexText = /^974\d{2}$/;
        break;
      case 'BL': //Saint Barth�lemy
        regexText = /^97133$/;
        break;
      case 'SH': //Saint Helena
        regexText = /^[Ss][Tt][Hh][Ll]\s{0,1}[1][Zz]{2}$/;
        break;
      case 'MF': //Saint Martin
        regexText = /^97150$/;
        break;
      case 'PM': //Saint Pierre and Miquelon
        regexText = /^97500$/;
        break;
      case 'VC': //Saint Vincent and the Grenadines
        regexText = /^[Vv][Cc]\d{4}$/;
        break;
      case 'SM': //San Marino
        regexText = /^4789\d$/;
        break;
      case 'SA': //Saudi Arabia
        regexText = /^\d{5}(-{1}\d{4})?$/;
        break;
      case 'SK': //Slovakia
        regexText = /^\d{5}\s\(\d{3}\s\d{2}\)$/;
        break;
      case 'SI': //Slovenia
        regexText = /^([Ss][Ii][- ]{0,1}){0,1}\d{4}$/;
        break;
      case 'GS': //South Georgia and the South Sandwich Islands
        regexText = /^[Ss][Ii][Qq]{2}\s{0,1}[1][Zz]{2}$/;
        break;
      case 'SZ': //Swaziland
        regexText = /^[A-Za-z]\d{3}$/;
        break;
      case 'SE': //Sweden
        regexText = /^\d{3}\s*\d{2}$/;
        break;
      // case 'SH': //Tristan da Cunha
      //     regexText = /^[Tt][Dd][Cc][Uu]\s{0,1}[1][Zz]{2}$/;
      //     break;
      case 'TC': //Turks and Caicos Islands
        regexText = /^[Tt][Kk][Cc][Aa]\s{0,1}[1][Zz]{2}$/;
        break;
      case 'GB': //United Kingdom
        regexText = /[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}/;
        break;
      case 'US': //United States
        regexText = /^\b\d{5}\b(?:[- ]{1}\d{4})?$/;
        break;
      case 'UZ': //Uzbekistan
        regexText = /^\d{3} \d{3}$/;
        break;
      case 'VA': //Vatican
        regexText = /^120$/;
        break;
      case 'VE': //Venezuela
        regexText = /^\d{4}(\s[a-zA-Z]{1})?$/;
        break;
      case 'WF': //Wallis and Futuna
        regexText = /^986\d{2}$/;
        break;
      default:
    }

    if (!regexText.test(zip)) {
      status = false;
    }
  }

  return status;
};

export const unitConverter = (num) => {
  return num > 999 ? (num / 1000).toFixed(1).replace('.0', '') + 'K' : num;
};

export const changeCdnUrl = (url) => {
  if (!url) {
    return url;
  }

  return cdnUrl + url.match(/(Images(.*))/g);
};
export const containsInput = (value, input) => {
  if (typeof value !== 'string') {
    return false;
  }
  const isValidInput = value.toLowerCase().includes(input.toLowerCase());
  return isValidInput;
};
export const openCustomURL = (url) => {
  if (Platform.OS === 'web') {
    WebBrowser.openBrowserAsync(url);
  } else {
    Linking.openURL(url);
  }
};
export const isNullOrEmpty = (value) => {
  // Check for undefined or null
  if (value === undefined || value === null) {
    return true;
  }
  // Check for empty strings
  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }
  // Check for empty arrays
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  // Check for empty objects
  if (typeof value === 'object' && Object.keys(value).length === 0) {
    return true;
  }
  return false;
};

export const validateEmail = (email) => {
  const EMAIL_REGEXP = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return EMAIL_REGEXP.test(email);
};

//to generate GUID
export const generate_uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    const uuid = (Math.random() * 16) | 0,
      v = c == 'x' ? uuid : (uuid & 0x3) | 0x8;
    return uuid.toString(16);
  });
};

export const GetPlatformId = (Platform) => {
  switch (Platform.OS) {
    case Source.IOS:
      return 3;
    case Source.ANDROID:
      return 2;
    default:
      return 1;
  }
};

export function getInputTypesForCurrentExpenseItem(subCategoryId) {
  for (let i = 0; i < ExpenseCategories.length; i++) {
    const currentCat = ExpenseCategories[i].SubCategories.filter(
      (cat) => cat.SubCategoryId === subCategoryId
    )[0];
    if (!isNullOrEmpty(currentCat)) {
      return currentCat;
    }
  }
  return {};
}

export function buildInitialStateForSelectedExpense(expenseItem) {
  const category = getInputTypesForCurrentExpenseItem(expenseItem.ExpenseSubCategory);
  const initialState = {
    image: null,
    [expenseActions.MERCHANT]: expenseItem.Merchant,
    [expenseActions.PARTICIPANTS]: expenseItem.Participants,
    [expenseActions.CLIENT]: expenseItem.Client,
    [expenseActions.DATE]: expenseItem.ExpenseDate,
    currency: expenseItem.Currency,
    [expenseActions.COST]: expenseItem.Amount,
    [expenseActions.CATEGORY]: expenseItem.ExpenseSubCategory,
    [expenseActions.ATTENDEES]: expenseItem.Attendees,
    userBelongToExpense: true,
    [expenseActions.REIMBURSABLE]: expenseItem.Reimbursable,
    [expenseActions.BILLABLE_TYPE]: expenseItem.BillableType,
    [expenseActions.PURPOSE]: expenseItem.Purpose,
    [expenseActions.COST_CENTER]: expenseItem.CostCenterType,
    [expenseActions.STARTDISTANCE]: '',
    [expenseActions.STARTDISTANCEIMAGE]: null,
    [expenseActions.ENDDISTANCE]: '',
    [expenseActions.ENDDISTANCEIMAGE]: null,
    [expenseActions.TOTALDISTANCE]: 0,
    unit: 'miles',
    [expenseActions.DISTANCERATE]: expenseItem.DistanceRate,
    desc: '',
    errors: {},
    [expenseActions.INPUT_TYPE]: ManualCategoryField(category),
    [expenseActions.MILEAGE_LOCATION_FROM]: '',
    [expenseActions.CALCULATION]: expenseItem.Calculation,
    [expenseActions.MILEAGE_LOCATION_TO]: '',
    [expenseActions.DISTANCE]: 0,
    [expenseActions.RATE]: expenseItem.Rate,
    [expenseActions.SUB_CATEGORY]: expenseItem.ExpenseCategory,
    [expenseActions.LOCATION]: expenseItem.Location,
    paymentType: expenseItem.PaymentType,
    From: expenseItem.LocationFrom,
    To: expenseItem.LocationTo,
    [expenseActions.ORIGIN_CITY_NAME]: expenseItem.OriginCityName,
    [expenseActions.DESTINATION_CITY_NAME]: expenseItem.DestinationCityName,
  };
  return initialState;
}

export const filterPendingReports = (reportsList) => {
  if (isNullOrEmpty(reportsList)) {
    return [];
  }
  if (!Array.isArray(reportsList)) {
    return [];
  }
  return reportsList?.filter((report) => report.Status === REPORT_STATUS.PENDING).filter(Boolean);
};

export const filterReportsForNewExpense = (reportsList) => {
  return filterPendingReports(reportsList)?.map((item) =>
    appendReportNumber(item?.Name, item?.ReportNumber)
  );
};

export const removeLostReceipt = (receipts) => {
  if (isNullOrEmpty(receipts)) {
    return [];
  }
  return receipts?.filter((receipt) => receipt.id !== LOST_RECEIPT_OPTION.id);
};

export const assignReceiptId = (receipts) => {
  let previousReceipt = null;
  return receipts.map((receipt) => {
    if (isNullOrEmpty(receipt?.id)) {
      if (previousReceipt) {
        receipt.id = previousReceipt.id + 1;
      } else {
        receipt.id = 1;
      }
    }
    previousReceipt = receipt;
    return receipt;
  });
};

export const removeObjectEmptyValues = (fields) => {
  return Object.keys(fields).reduce((acc, key) => {
    // don't replace Payment Type because it must be an object
    if (!isNullOrEmpty(fields[key])) {
      acc[key] = fields[key];
    }
    return acc;
  }, {});
};

export const isPdf = (s3FileName) => {
  // Ensure the input is valid and check if it ends with ".pdf" (case-insensitive)
  return typeof s3FileName === 'string' && s3FileName.trim().toLowerCase().endsWith('.pdf');
};
